import { render, staticRenderFns } from "./EmptyAlerts.vue?vue&type=template&id=8eb27ea4&scoped=true&"
import script from "./EmptyAlerts.vue?vue&type=script&lang=js&"
export * from "./EmptyAlerts.vue?vue&type=script&lang=js&"
import style0 from "./EmptyAlerts.vue?vue&type=style&index=0&id=8eb27ea4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb27ea4",
  null
  
)

export default component.exports